// This file is autogenerated by default-tables.mjs

/**
 * CSV columns: type, code, key, description, risk
 */
export const DEFAULT_TABLE_INDUSTRIES = {
  columns: ['type', 'code', 'key', 'description', 'risk'],
  entries: [
    ['ISIC', '0112', 'ISIC0112', 'Growing of rice', 'high'],
    ['ISIC', '0114', 'ISIC0114', 'Growing of sugar cane', 'high'],
    ['ISIC', '0116', 'ISIC0116', 'Growing of fibre crops', 'high'],
    [
      'ISIC',
      '0122',
      'ISIC0122',
      'Growing of tropical and subtropical fruits',
      'high',
    ],
    [
      'ISIC',
      '0128',
      'ISIC0128',
      'Growing of spices, aromatic, drug and pharmaceutical crops',
      'high',
    ],
    [
      'ISIC',
      '0170',
      'ISIC0170',
      'Hunting, trapping and related service activities',
      'high',
    ],
    ['ISIC', '0311', 'ISIC0311', 'Marine fishing', 'high'],
    ['ISIC', '0312', 'ISIC0312', 'Freshwater fishing', 'high'],
    ['ISIC', '1072', 'ISIC1072', 'Manufacture of sugar', 'high'],
    [
      'ISIC',
      '1073',
      'ISIC1073',
      'Manufacture of cocoa, chocolate and sugar confectionery',
      'high',
    ],
    [
      'ISIC',
      '1079',
      'ISIC1079',
      'Manufacture of other food products n.e.c.',
      'high',
    ],
    ['ISIC', '1811', 'ISIC1811', 'Printing', 'high'],
    [
      'ISIC',
      '1812',
      'ISIC1812',
      'Service activities related to printing',
      'high',
    ],
    ['ISIC', '1820', 'ISIC1820', 'Reproduction of recorded media', 'high'],
    ['ISIC', '2011', 'ISIC2011', 'Manufacture of basic chemicals', 'high'],
    [
      'ISIC',
      '2012',
      'ISIC2012',
      'Manufacture of fertilizers and nitrogen compounds',
      'high',
    ],
    [
      'ISIC',
      '2013',
      'ISIC2013',
      'Manufacture of plastics and synthetic rubber in primary forms',
      'high',
    ],
    [
      'ISIC',
      '2022',
      'ISIC2022',
      'Manufacture of paints, varnishes and similar coatings, printing ink and mastics',
      'high',
    ],
    [
      'ISIC',
      '2023',
      'ISIC2023',
      'Manufacture of soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations',
      'high',
    ],
    [
      'ISIC',
      '2029',
      'ISIC2029',
      'Manufacture of other chemical products n.e.c.',
      'high',
    ],
    [
      'ISIC',
      '2100',
      'ISIC2100',
      'Manufacture of pharmaceuticals, medicinal chemical and botanical products',
      'high',
    ],
    [
      'ISIC',
      '2420',
      'ISIC2420',
      'Manufacture of basic precious and other non-ferrous metals',
      'high',
    ],
    [
      'ISIC',
      '2593',
      'ISIC2593',
      'Manufacture of cutlery, hand tools and general hardware',
      'high',
    ],
    [
      'ISIC',
      '2610',
      'ISIC2610',
      'Manufacture of electronic components and boards',
      'high',
    ],
    ['ISIC', '2652', 'ISIC2652', 'Manufacture of watches and clocks', 'high'],
    [
      'ISIC',
      '2660',
      'ISIC2660',
      'Manufacture of irradiation, electromedical and electrotherapeutic equipment',
      'high',
    ],
    [
      'ISIC',
      '2670',
      'ISIC2670',
      'Manufacture of optical instruments and photographic equipment',
      'high',
    ],
    [
      'ISIC',
      '2790',
      'ISIC2790',
      'Manufacture of other electrical equipment',
      'high',
    ],
    [
      'ISIC',
      '2811',
      'ISIC2811',
      'Manufacture of engines and turbines, except aircraft, vehicle and cycle engines',
      'high',
    ],
    [
      'ISIC',
      '2812',
      'ISIC2812',
      'Manufacture of fluid power equipment',
      'high',
    ],
    [
      'ISIC',
      '2813',
      'ISIC2813',
      'Manufacture of other pumps, compressors, taps and valves',
      'high',
    ],
    [
      'ISIC',
      '2814',
      'ISIC2814',
      'Manufacture of bearings, gears, gearing and driving elements',
      'high',
    ],
    [
      'ISIC',
      '2819',
      'ISIC2819',
      'Manufacture of other general-purpose machinery',
      'high',
    ],
    [
      'ISIC',
      '2829',
      'ISIC2829',
      'Manufacture of other special-purpose machinery',
      'high',
    ],
    [
      'ISIC',
      '2930',
      'ISIC2930',
      'Manufacture of parts and accessories for motor vehicles',
      'high',
    ],
    [
      'ISIC',
      '3011',
      'ISIC3011',
      'Building of ships and floating structures',
      'high',
    ],
    [
      'ISIC',
      '3030',
      'ISIC3030',
      'Manufacture of air and spacecraft and related machinery',
      'high',
    ],
    [
      'ISIC',
      '3211',
      'ISIC3211',
      'Manufacture of jewellery and related articles',
      'high',
    ],
    [
      'ISIC',
      '3212',
      'ISIC3212',
      'Manufacture of imitation jewellery and related articles',
      'high',
    ],
    ['ISIC', '3811', 'ISIC3811', 'Collection of non-hazardous waste', 'high'],
    ['ISIC', '3812', 'ISIC3812', 'Collection of hazardous waste', 'high'],
    [
      'ISIC',
      '3821',
      'ISIC3821',
      'Treatment and disposal of non-hazardous waste',
      'high',
    ],
    [
      'ISIC',
      '3822',
      'ISIC3822',
      'Treatment and disposal of hazardous waste',
      'high',
    ],
    ['ISIC', '3830', 'ISIC3830', 'Materials recovery', 'high'],
    [
      'ISIC',
      '3900',
      'ISIC3900',
      'Remediation activities and other waste management services',
      'high',
    ],
    ['ISIC', '4100', 'ISIC4100', 'Construction of buildings', 'high'],
    ['ISIC', '4210', 'ISIC4210', 'Construction of roads and railways', 'high'],
    ['ISIC', '4220', 'ISIC4220', 'Construction of utility projects', 'high'],
    [
      'ISIC',
      '4290',
      'ISIC4290',
      'Construction of other civil engineering projects',
      'high',
    ],
    [
      'ISIC',
      '4520',
      'ISIC4520',
      'Maintenance and repair of motor vehicles',
      'high',
    ],
    [
      'ISIC',
      '4530',
      'ISIC4530',
      'Sale of motor vehicle parts and accessories',
      'high',
    ],
    [
      'ISIC',
      '4610',
      'ISIC4610',
      'Wholesale on a fee or contract basis',
      'high',
    ],
    ['ISIC', '4649', 'ISIC4649', 'Wholesale of other household goods', 'high'],
    [
      'ISIC',
      '4652',
      'ISIC4652',
      'Wholesale of electronic and telecommunications equipment and parts',
      'high',
    ],
    [
      'ISIC',
      '4761',
      'ISIC4761',
      'Retail sale of books, newspapers and stationary in specialized stores',
      'high',
    ],
    [
      'ISIC',
      '4773',
      'ISIC4773',
      'Other retail sale of new goods in specialized stores',
      'high',
    ],
    [
      'ISIC',
      '4782',
      'ISIC4782',
      'Retail sale via stalls and markets of textiles, clothing and footwear',
      'high',
    ],
    [
      'ISIC',
      '4789',
      'ISIC4789',
      'Retail sale via stalls and markets of other goods',
      'high',
    ],
    [
      'ISIC',
      '4791',
      'ISIC4791',
      'Retail sale via mail order houses or via Internet',
      'high',
    ],
    [
      'ISIC',
      '4799',
      'ISIC4799',
      'Other retail sale not in stores, stalls or markets',
      'high',
    ],
    [
      'ISIC',
      '5221',
      'ISIC5221',
      'Service activities incidental to land transportation',
      'high',
    ],
    [
      'ISIC',
      '5222',
      'ISIC5222',
      'Service activities incidental to water transportation',
      'high',
    ],
    [
      'ISIC',
      '5223',
      'ISIC5223',
      'Service activities incidental to air transportation',
      'high',
    ],
    ['ISIC', '5224', 'ISIC5224', 'Cargo handling', 'high'],
    [
      'ISIC',
      '5229',
      'ISIC5229',
      'Other transportation support activities',
      'high',
    ],
    ['ISIC', '5310', 'ISIC5310', 'Postal activities', 'high'],
    ['ISIC', '5320', 'ISIC5320', 'Courier activities', 'high'],
    ['ISIC', '5510', 'ISIC5510', 'Short term accommodation activities', 'high'],
    [
      'ISIC',
      '5520',
      'ISIC5520',
      'Camping grounds, recreational vehicle parks and trailer parks',
      'high',
    ],
    ['ISIC', '5590', 'ISIC5590', 'Other accommodation', 'high'],
    [
      'ISIC',
      '5610',
      'ISIC5610',
      'Restaurants and mobile food service activities',
      'high',
    ],
    ['ISIC', '5621', 'ISIC5621', 'Event catering', 'high'],
    ['ISIC', '5629', 'ISIC5629', 'Other food service activities', 'high'],
    ['ISIC', '5630', 'ISIC5630', 'Beverage serving activities', 'high'],
    ['ISIC', '5811', 'ISIC5811', 'Book publishing', 'high'],
    [
      'ISIC',
      '5812',
      'ISIC5812',
      'Publishing of directories and mailing lists',
      'high',
    ],
    [
      'ISIC',
      '5813',
      'ISIC5813',
      'Publishing of newspapers, journals and periodicals',
      'high',
    ],
    ['ISIC', '5819', 'ISIC5819', 'Other publishing activities', 'high'],
    [
      'ISIC',
      '5911',
      'ISIC5911',
      'Motion picture, video and television programme production activities',
      'high',
    ],
    [
      'ISIC',
      '5913',
      'ISIC5913',
      'Motion picture, video and television programme distribution activities',
      'high',
    ],
    [
      'ISIC',
      '5914',
      'ISIC5914',
      'Motion picture projection activities',
      'high',
    ],
    [
      'ISIC',
      '5920',
      'ISIC5920',
      'Sound recording and music publishing activities',
      'high',
    ],
    [
      'ISIC',
      '6020',
      'ISIC6020',
      'Television programming and broadcasting activities',
      'high',
    ],
    ['ISIC', '6419', 'ISIC6419', 'Other monetary intermediation', 'high'],
    [
      'ISIC',
      '6430',
      'ISIC6430',
      'Trusts, funds and similar financial entities',
      'high',
    ],
    ['ISIC', '6492', 'ISIC6492', 'Other credit granting', 'high'],
    [
      'ISIC',
      '6499',
      'ISIC6499',
      'Other financial service activities, except insurance and pension funding activities, n.e.c.',
      'high',
    ],
    [
      'ISIC',
      '6612',
      'ISIC6612',
      'Security and commodity contracts brokerage',
      'high',
    ],
    ['ISIC', '6630', 'ISIC6630', 'Fund management activities', 'high'],
    [
      'ISIC',
      '6810',
      'ISIC6810',
      'Real estate activities with own or leased property',
      'high',
    ],
    [
      'ISIC',
      '6820',
      'ISIC6820',
      'Real estate activities on a fee or contract basis',
      'high',
    ],
    ['ISIC', '6910', 'ISIC6910', 'Legal activities', 'high'],
    [
      'ISIC',
      '6920',
      'ISIC6920',
      'Accounting, bookkeeping and auditing activities; tax consultancy',
      'high',
    ],
    ['ISIC', '7020', 'ISIC7020', 'Management consultancy activities', 'high'],
    ['ISIC', '7722', 'ISIC7722', 'Renting of video tapes and disks', 'high'],
    ['ISIC', '8010', 'ISIC8010', 'Private security activities', 'high'],
    ['ISIC', '8030', 'ISIC8030', 'Investigation activities', 'high'],
    [
      'ISIC',
      '8291',
      'ISIC8291',
      'Activities of collection agencies and credit bureaus',
      'high',
    ],
    ['ISIC', '8422', 'ISIC8422', 'Defence activities', 'high'],
    ['ISIC', '8423', 'ISIC8423', 'Public order and safety activities', 'high'],
    ['ISIC', '9200', 'ISIC9200', 'Gambling and betting activities', 'high'],
    [
      'ISIC',
      '9601',
      'ISIC9601',
      'Washing and (dry-) cleaning of textile and fur products',
      'high',
    ],
    [
      'ISIC',
      '9602',
      'ISIC9602',
      'Hairdressing and other beauty treatment',
      'high',
    ],
    ['ISIC', '9603', 'ISIC9603', 'Funeral and related activities', 'high'],
    [
      'ISIC',
      '9609',
      'ISIC9609',
      'Other personal service activities n.e.c.',
      'high',
    ],
    [
      'NACE',
      '01.13',
      'NACE01.13',
      'Growing of vegetables and melons, roots and tubers',
      'high',
    ],
    ['NACE', '01.15', 'NACE01.15', 'Growing of tobacco', 'high'],
    [
      'NACE',
      '01.19',
      'NACE01.19',
      'Growing of other non-perennial crops',
      'high',
    ],
    ['NACE', '01.23', 'NACE01.23', 'Growing of citrus fruits', 'high'],
    ['NACE', '01.29', 'NACE01.29', 'Growing of other perennial crops', 'high'],
    ['NACE', '02', 'NACE02', 'Forestry and logging', 'high'],
    ['NACE', '03.12', 'NACE03.12', 'Freshwater fishing', 'high'],
    ['NACE', '03.2', 'NACE03.2', 'Aquaculture', 'high'],
    [
      'NACE',
      '10.82',
      'NACE10.82',
      'Manufacture of cocoa, chocolate and sugar confectionery',
      'high',
    ],
    ['NACE', '10.83', 'NACE10.83', 'Processing of tea and coffee', 'high'],
    [
      'NACE',
      '10.84',
      'NACE10.84',
      'Manufacture of condiments and seasonings',
      'high',
    ],
    ['NACE', '18.12', 'NACE18.12', 'Other printing', 'high'],
    ['NACE', '18.13', 'NACE18.13', 'Pre-press and pre-media services', 'high'],
    ['NACE', '18.14', 'NACE18.14', 'Binding and related services', 'high'],
    ['NACE', '18.2', 'NACE18.2', 'Reproduction of recorded media', 'high'],
    [
      'NACE',
      '19',
      'NACE19',
      'Manufacture of coke and refined petroleum products',
      'high',
    ],
    ['NACE', '20.12', 'NACE20.12', 'Manufacture of dyes and pigments', 'high'],
    [
      'NACE',
      '20.13',
      'NACE20.13',
      'Manufacture of other inorganic basic chemicals',
      'high',
    ],
    [
      'NACE',
      '20.14',
      'NACE20.14',
      'Manufacture of other organic basic chemicals',
      'high',
    ],
    [
      'NACE',
      '20.15',
      'NACE20.15',
      'Manufacture of fertilisers and nitrogen compounds',
      'high',
    ],
    [
      'NACE',
      '20.16',
      'NACE20.16',
      'Manufacture of plastics in primary forms',
      'high',
    ],
    [
      'NACE',
      '20.17',
      'NACE20.17',
      'Manufacture of synthetic rubber in primary forms',
      'high',
    ],
    [
      'NACE',
      '20.4',
      'NACE20.4',
      'Manufacture of soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations',
      'high',
    ],
    [
      'NACE',
      '20.42',
      'NACE20.42',
      'Manufacture of perfumes and toilet preparations',
      'high',
    ],
    [
      'NACE',
      '20.5',
      'NACE20.5',
      'Manufacture of other chemical products',
      'high',
    ],
    ['NACE', '20.53', 'NACE20.53', 'Manufacture of essential oils', 'high'],
    [
      'NACE',
      '20.59',
      'NACE20.59',
      'Manufacture of other chemical products n.e.c.',
      'high',
    ],
    ['NACE', '20.6', 'NACE20.6', 'Manufacture of man-made fibres', 'high'],
    [
      'NACE',
      '21.2',
      'NACE21.2',
      'Manufacture of pharmaceutical preparations',
      'high',
    ],
    [
      'NACE',
      '22',
      'NACE22',
      'Manufacture of rubber and plastic products',
      'high',
    ],
    ['NACE', '24.5', 'NACE24.5', 'Casting of metals', 'high'],
    ['NACE', '25.72', 'NACE25.72', 'Manufacture of locks and hinges', 'high'],
    [
      'NACE',
      '26.12',
      'NACE26.12',
      'Manufacture of loaded electronic boards',
      'high',
    ],
    [
      'NACE',
      '26.2',
      'NACE26.2',
      'Manufacture of computers and peripheral equipment',
      'high',
    ],
    ['NACE', '26.52', 'NACE26.52', 'Manufacture of watches and clocks', 'high'],
    [
      'NACE',
      '26.6',
      'NACE26.6',
      'Manufacture of irradiation, electromedical and electrotherapeutic equipment',
      'high',
    ],
    [
      'NACE',
      '26.7',
      'NACE26.7',
      'Manufacture of optical instruments and photographic equipment',
      'high',
    ],
    [
      'NACE',
      '26.8',
      'NACE26.8',
      'Manufacture of magnetic and optical media',
      'high',
    ],
    [
      'NACE',
      '28',
      'NACE28',
      'Manufacture of machinery and equipment n.e.c.',
      'high',
    ],
    [
      'NACE',
      '28.12',
      'NACE28.12',
      'Manufacture of fluid power equipment',
      'high',
    ],
    [
      'NACE',
      '28.13',
      'NACE28.13',
      'Manufacture of other pumps and compressors',
      'high',
    ],
    [
      'NACE',
      '28.14',
      'NACE28.14',
      'Manufacture of other taps and valves',
      'high',
    ],
    [
      'NACE',
      '28.15',
      'NACE28.15',
      'Manufacture of bearings, gears, gearing and driving elements',
      'high',
    ],
    [
      'NACE',
      '28.2',
      'NACE28.2',
      'Manufacture of other general-purpose machinery',
      'high',
    ],
    [
      'NACE',
      '28.3',
      'NACE28.3',
      'Manufacture of agricultural and forestry machinery',
      'high',
    ],
    [
      'NACE',
      '29',
      'NACE29',
      'Manufacture of motor vehicles, trailers and semi-trailers',
      'high',
    ],
    [
      'NACE',
      '29.32',
      'NACE29.32',
      'Manufacture of other parts and accessories for motor vehicles',
      'high',
    ],
    [
      'NACE',
      '30',
      'NACE30',
      'Manufacture of other transport equipment',
      'high',
    ],
    [
      'NACE',
      '30.12',
      'NACE30.12',
      'Building of pleasure and sporting boats',
      'high',
    ],
    [
      'NACE',
      '30.4',
      'NACE30.4',
      'Manufacture of military fighting vehicles',
      'high',
    ],
    [
      'NACE',
      '32.12',
      'NACE32.12',
      'Manufacture of jewellery and related articles',
      'high',
    ],
    [
      'NACE',
      '32.13',
      'NACE32.13',
      'Manufacture of imitation jewellery and related articles',
      'high',
    ],
    ['NACE', '32.2', 'NACE32.2', 'Manufacture of musical instruments', 'high'],
    ['NACE', '38.12', 'NACE38.12', 'Collection of hazardous waste', 'high'],
    ['NACE', '38.2', 'NACE38.2', 'Waste treatment and disposal', 'high'],
    [
      'NACE',
      '38.22',
      'NACE38.22',
      'Treatment and disposal of hazardous waste',
      'high',
    ],
    ['NACE', '38.3', 'NACE38.3', 'Materials recovery', 'high'],
    ['NACE', '38.32', 'NACE38.32', 'Recovery of sorted materials', 'high'],
    [
      'NACE',
      '39',
      'NACE39',
      'Remediation activities and other waste management services',
      'high',
    ],
    ['NACE', 'F', 'NACEF', 'CONSTRUCTION', 'high'],
    [
      'NACE',
      '41.2',
      'NACE41.2',
      'Construction of residential and non-residential buildings',
      'high',
    ],
    ['NACE', '42', 'NACE42', 'Civil engineering', 'high'],
    [
      'NACE',
      '42.12',
      'NACE42.12',
      'Construction of railways and underground railways',
      'high',
    ],
    [
      'NACE',
      '42.13',
      'NACE42.13',
      'Construction of bridges and tunnels',
      'high',
    ],
    ['NACE', '42.2', 'NACE42.2', 'Construction of utility projects', 'high'],
    [
      'NACE',
      '42.22',
      'NACE42.22',
      'Construction of utility projects for electricity and telecommunications',
      'high',
    ],
    [
      'NACE',
      '42.9',
      'NACE42.9',
      'Construction of other civil engineering projects',
      'high',
    ],
    [
      'NACE',
      '42.99',
      'NACE42.99',
      'Construction of other civil engineering projects n.e.c.',
      'high',
    ],
    ['NACE', '43', 'NACE43', 'Specialised construction activities', 'high'],
    [
      'NACE',
      '45.3',
      'NACE45.3',
      'Sale of motor vehicle parts and accessories',
      'high',
    ],
    [
      'NACE',
      '45.32',
      'NACE45.32',
      'Retail trade of motor vehicle parts and accessories',
      'high',
    ],
    [
      'NACE',
      '45.4',
      'NACE45.4',
      'Sale, maintenance and repair of motorcycles and related parts and accessories',
      'high',
    ],
    [
      'NACE',
      '46',
      'NACE46',
      'Wholesale trade, except of motor vehicles and motorcycles',
      'high',
    ],
    [
      'NACE',
      '46.12',
      'NACE46.12',
      'Agents involved in the sale of fuels, ores, metals and industrial chemicals',
      'high',
    ],
    [
      'NACE',
      '46.13',
      'NACE46.13',
      'Agents involved in the sale of timber and building materials',
      'high',
    ],
    [
      'NACE',
      '46.14',
      'NACE46.14',
      'Agents involved in the sale of machinery, industrial equipment, ships and aircraft',
      'high',
    ],
    [
      'NACE',
      '46.15',
      'NACE46.15',
      'Agents involved in the sale of furniture, household goods, hardware and ironmongery',
      'high',
    ],
    [
      'NACE',
      '46.16',
      'NACE46.16',
      'Agents involved in the sale of textiles, clothing, fur, footwear and leather goods',
      'high',
    ],
    [
      'NACE',
      '46.17',
      'NACE46.17',
      'Agents involved in the sale of food, beverages and tobacco',
      'high',
    ],
    [
      'NACE',
      '46.18',
      'NACE46.18',
      'Agents specialised in the sale of other particular products',
      'high',
    ],
    [
      'NACE',
      '46.19',
      'NACE46.19',
      'Agents involved in the sale of a variety of goods',
      'high',
    ],
    [
      'NACE',
      '46.2',
      'NACE46.2',
      'Wholesale of agricultural raw materials and live animals',
      'high',
    ],
    [
      'NACE',
      '46.49',
      'NACE46.49',
      'Wholesale of other household goods',
      'high',
    ],
    [
      'NACE',
      '46.5',
      'NACE46.5',
      'Wholesale of information and communication equipment',
      'high',
    ],
    [
      'NACE',
      '46.6',
      'NACE46.6',
      'Wholesale of other machinery, equipment and supplies',
      'high',
    ],
    ['NACE', '46.9', 'NACE46.9', 'Non-specialised wholesale trade', 'high'],
    [
      'NACE',
      '47.62',
      'NACE47.62',
      'Retail sale of newspapers and stationery in specialised stores',
      'high',
    ],
    [
      'NACE',
      '47.78',
      'NACE47.78',
      'Other retail sale of new goods in specialised stores',
      'high',
    ],
    [
      'NACE',
      '47.82',
      'NACE47.82',
      'Retail sale via stalls and markets of textiles, clothing and footwear',
      'high',
    ],
    [
      'NACE',
      '47.89',
      'NACE47.89',
      'Retail sale via stalls and markets of other goods',
      'high',
    ],
    [
      'NACE',
      '47.9',
      'NACE47.9',
      'Retail trade not in stores, stalls or markets',
      'high',
    ],
    [
      'NACE',
      '47.99',
      'NACE47.99',
      'Other retail sale not in stores, stalls or markets',
      'high',
    ],
    ['NACE', 'H', 'NACEH', 'TRANSPORTATION AND STORAGE', 'high'],
    [
      'NACE',
      '52.22',
      'NACE52.22',
      'Service activities incidental to water transportation',
      'high',
    ],
    [
      'NACE',
      '52.23',
      'NACE52.23',
      'Service activities incidental to air transportation',
      'high',
    ],
    ['NACE', '52.24', 'NACE52.24', 'Cargo handling', 'high'],
    [
      'NACE',
      '52.29',
      'NACE52.29',
      'Other transportation support activities',
      'high',
    ],
    ['NACE', '53', 'NACE53', 'Postal and courier activities', 'high'],
    ['NACE', '53.2', 'NACE53.2', 'Other postal and courier activities', 'high'],
    ['NACE', 'I', 'NACEI', 'ACCOMMODATION AND FOOD SERVICE ACTIVITIES', 'high'],
    [
      'NACE',
      '55.2',
      'NACE55.2',
      'Holiday and other short-stay accommodation',
      'high',
    ],
    [
      'NACE',
      '55.3',
      'NACE55.3',
      'Camping grounds, recreational vehicle parks and trailer parks',
      'high',
    ],
    ['NACE', '55.9', 'NACE55.9', 'Other accommodation', 'high'],
    ['NACE', '56', 'NACE56', 'Food and beverage service activities', 'high'],
    [
      'NACE',
      '56.2',
      'NACE56.2',
      'Event catering and other food service activities',
      'high',
    ],
    ['NACE', '56.29', 'NACE56.29', 'Other food service activities', 'high'],
    ['NACE', '56.3', 'NACE56.3', 'Beverage serving activities', 'high'],
    ['NACE', 'J', 'NACEJ', 'INFORMATION AND COMMUNICATION', 'high'],
    [
      'NACE',
      '58.12',
      'NACE58.12',
      'Publishing of directories and mailing lists',
      'high',
    ],
    ['NACE', '58.13', 'NACE58.13', 'Publishing of newspapers', 'high'],
    [
      'NACE',
      '58.14',
      'NACE58.14',
      'Publishing of journals and periodicals',
      'high',
    ],
    ['NACE', '58.19', 'NACE58.19', 'Other publishing activities', 'high'],
    ['NACE', '58.2', 'NACE58.2', 'Software publishing', 'high'],
    [
      'NACE',
      '59.12',
      'NACE59.12',
      'Motion picture, video and television programme post-production activities',
      'high',
    ],
    [
      'NACE',
      '59.13',
      'NACE59.13',
      'Motion picture, video and television programme distribution activities',
      'high',
    ],
    [
      'NACE',
      '59.14',
      'NACE59.14',
      'Motion picture projection activities',
      'high',
    ],
    [
      'NACE',
      '59.2',
      'NACE59.2',
      'Sound recording and music publishing activities',
      'high',
    ],
    ['NACE', '60', 'NACE60', 'Programming and broadcasting activities', 'high'],
    ['NACE', '61', 'NACE61', 'Telecommunications', 'high'],
    ['NACE', '64.2', 'NACE64.2', 'Activities of holding companies', 'high'],
    [
      'NACE',
      '64.9',
      'NACE64.9',
      'Other financial service activities, except insurance and pension funding',
      'high',
    ],
    [
      'NACE',
      '64.99',
      'NACE64.99',
      'Other financial service activities, except insurance and pension funding n.e.c.',
      'high',
    ],
    [
      'NACE',
      '65',
      'NACE65',
      'Insurance, reinsurance and pension funding, except compulsory social security',
      'high',
    ],
    [
      'NACE',
      '66.19',
      'NACE66.19',
      'Other activities auxiliary to financial services, except insurance and pension funding',
      'high',
    ],
    [
      'NACE',
      '66.2',
      'NACE66.2',
      'Activities auxiliary to insurance and pension funding',
      'high',
    ],
    ['NACE', 'L', 'NACEL', 'REAL ESTATE ACTIVITIES', 'high'],
    [
      'NACE',
      '68.2',
      'NACE68.2',
      'Renting and operating of own or leased real estate',
      'high',
    ],
    [
      'NACE',
      '68.3',
      'NACE68.3',
      'Real estate activities on a fee or contract basis',
      'high',
    ],
    [
      'NACE',
      '68.32',
      'NACE68.32',
      'Management of real estate on a fee or contract basis',
      'high',
    ],
    [
      'NACE',
      'M',
      'NACEM',
      'PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES',
      'high',
    ],
    [
      'NACE',
      '69.2',
      'NACE69.2',
      'Accounting, bookkeeping and auditing activities; tax consultancy',
      'high',
    ],
    [
      'NACE',
      '70',
      'NACE70',
      'Activities of head offices; management consultancy activities',
      'high',
    ],
    [
      'NACE',
      '70.22',
      'NACE70.22',
      'Business and other management consultancy activities',
      'high',
    ],
    [
      'NACE',
      '77.29',
      'NACE77.29',
      'Renting and leasing of other personal and household goods',
      'high',
    ],
    ['NACE', '80.2', 'NACE80.2', 'Security systems service activities', 'high'],
    [
      'NACE',
      '81',
      'NACE81',
      'Services to buildings and landscape activities',
      'high',
    ],
    ['NACE', '82.92', 'NACE82.92', 'Packaging activities', 'high'],
    ['NACE', '84.23', 'NACE84.23', 'Justice and judicial activities', 'high'],
    [
      'NACE',
      '84.24',
      'NACE84.24',
      'Public order and safety activities',
      'high',
    ],
    ['NACE', '84.25', 'NACE84.25', 'Fire service activities', 'high'],
    [
      'NACE',
      '84.3',
      'NACE84.3',
      'Compulsory social security activities',
      'high',
    ],
    [
      'NACE',
      '93',
      'NACE93',
      'Sports activities and amusement and recreation activities',
      'high',
    ],
    [
      'NACE',
      '96.02',
      'NACE96.02',
      'Hairdressing and other beauty treatment',
      'high',
    ],
    ['NACE', '96.03', 'NACE96.03', 'Funeral and related activities', 'high'],
    ['NACE', '96.04', 'NACE96.04', 'Physical well-being activities', 'high'],
    [
      'NACE',
      '96.09',
      'NACE96.09',
      'Other personal service activities n.e.c.',
      'high',
    ],
    [
      'NACE',
      'T',
      'NACET',
      'ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS; U0NDIFFERENTIATED GOODS- AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE',
      'high',
    ],
    ['NAF', '05.10', 'NAF05.10', 'Extraction de houille', 'high'],
    ['NAF', '05.10Z', 'NAF05.10Z', 'Extraction de houille', 'high'],
    ['NAF', '05.20', 'NAF05.20', 'Extraction de lignite', 'high'],
    ['NAF', '05.20Z', 'NAF05.20Z', 'Extraction de lignite', 'high'],
    ['NAF', '06.10', 'NAF06.10', 'Extraction de pétrole brut', 'high'],
    ['NAF', '06.10Z', 'NAF06.10Z', 'Extraction de pétrole brut', 'high'],
    ['NAF', '06.20', 'NAF06.20', 'Extraction de gaz naturel', 'high'],
    ['NAF', '06.20Z', 'NAF06.20Z', 'Extraction de gaz naturel', 'high'],
    ['NAF', '07.10', 'NAF07.10', 'Extraction de minerais de fer', 'high'],
    ['NAF', '07.10Z', 'NAF07.10Z', 'Extraction de minerais de fer', 'high'],
    [
      'NAF',
      '07.21',
      'NAF07.21',
      "Extraction de minerais d'uranium et de thorium",
      'high',
    ],
    [
      'NAF',
      '07.21Z',
      'NAF07.21Z',
      "Extraction de minerais d'uranium et de thorium",
      'high',
    ],
    [
      'NAF',
      '07.29',
      'NAF07.29',
      "Extraction d'autres minerais de métaux non ferreux",
      'high',
    ],
    [
      'NAF',
      '07.29Z',
      'NAF07.29Z',
      "Extraction d'autres minerais de métaux non ferreux",
      'high',
    ],
    [
      'NAF',
      '08.91',
      'NAF08.91',
      "Extraction des minéraux chimiques et d'engrais minéraux",
      'high',
    ],
    [
      'NAF',
      '08.91Z',
      'NAF08.91Z',
      "Extraction des minéraux chimiques et d'engrais minéraux",
      'high',
    ],
    ['NAF', '08.92', 'NAF08.92', 'Extraction de tourbe', 'high'],
    ['NAF', '08.92Z', 'NAF08.92Z', 'Extraction de tourbe', 'high'],
    ['NAF', '08.93', 'NAF08.93', 'Production de sel', 'high'],
    ['NAF', '08.93Z', 'NAF08.93Z', 'Production de sel', 'high'],
    ['NAF', '08.99', 'NAF08.99', 'Autres activités extractives n.c.a.', 'high'],
    [
      'NAF',
      '08.99Z',
      'NAF08.99Z',
      'Autres activités extractives n.c.a.',
      'high',
    ],
    [
      'NAF',
      '09.10',
      'NAF09.10',
      "Activités de soutien à l'extraction d'hydrocarbures",
      'high',
    ],
    [
      'NAF',
      '09.10Z',
      'NAF09.10Z',
      "Activités de soutien à l'extraction d'hydrocarbures",
      'high',
    ],
    [
      'NAF',
      '09.90',
      'NAF09.90',
      'Activités de soutien aux autres industries extractives',
      'high',
    ],
    [
      'NAF',
      '20.15',
      'NAF20.15',
      "Fabrication de produits azotés et d'engrais",
      'high',
    ],
    [
      'NAF',
      '20.15Z',
      'NAF20.15Z',
      "Fabrication de produits azotés et d'engrais",
      'high',
    ],
    [
      'NAF',
      '20.5',
      'NAF20.5',
      "Fabrication d'autres produits chimiques",
      'high',
    ],
    ['NAF', '20.51', 'NAF20.51', 'Fabrication de produits explosifs', 'high'],
    ['NAF', '20.51Z', 'NAF20.51Z', 'Fabrication de produits explosifs', 'high'],
    [
      'NAF',
      '35.2',
      'NAF35.2',
      'Production et distribution de combustibles gazeux',
      'high',
    ],
    ['NAF', '35.21', 'NAF35.21', 'Production de combustibles gazeux', 'high'],
    ['NAF', '35.21Z', 'NAF35.21Z', 'Production de combustibles gazeux', 'high'],
    [
      'NAF',
      '35.22',
      'NAF35.22',
      'Distribution de combustibles gazeux par conduites',
      'high',
    ],
    [
      'NAF',
      '35.22Z',
      'NAF35.22Z',
      'Distribution de combustibles gazeux par conduites',
      'high',
    ],
    [
      'NAF',
      '35.23',
      'NAF35.23',
      'Commerce de combustibles gazeux par conduites',
      'high',
    ],
    [
      'NAF',
      '35.23Z',
      'NAF35.23Z',
      'Commerce de combustibles gazeux par conduites',
      'high',
    ],
    [
      'NAF',
      '38.11Z',
      'NAF38.11Z',
      'Collecte des déchets non dangereux',
      'high',
    ],
    ['NAF', '38.12', 'NAF38.12', 'Collecte des déchets dangereux', 'high'],
    ['NAF', '38.12Z', 'NAF38.12Z', 'Collecte des déchets dangereux', 'high'],
    [
      'NAF',
      '38.22',
      'NAF38.22',
      'Traitement et élimination des déchets dangereux',
      'high',
    ],
    [
      'NAF',
      '38.22Z',
      'NAF38.22Z',
      'Traitement et élimination des déchets dangereux',
      'high',
    ],
    ['NAF', '41', 'NAF41', 'Construction de bâtiments', 'high'],
    ['NAF', '41.1', 'NAF41.1', 'Promotion immobilière', 'high'],
    ['NAF', '41.10', 'NAF41.10', 'Promotion immobilière', 'high'],
    [
      'NAF',
      '41.10A',
      'NAF41.10A',
      'Promotion immobilière de logements',
      'high',
    ],
    ['NAF', '41.10B', 'NAF41.10B', 'Promotion immobilière de bureaux', 'high'],
    [
      'NAF',
      '41.10C',
      'NAF41.10C',
      "Promotion immobilière d'autres bâtiments",
      'high',
    ],
    ['NAF', '41.10D', 'NAF41.10D', 'Supports juridiques de programmes', 'high'],
    [
      'NAF',
      '46.35',
      'NAF46.35',
      'Commerce de gros de produits à base de tabac',
      'high',
    ],
    [
      'NAF',
      '47.26',
      'NAF47.26',
      'Commerce de détail de produits à base de tabac en magasin spécialisé',
      'high',
    ],
    [
      'NAF',
      '47.26Z',
      'NAF47.26Z',
      'Commerce de détail de produits à base de tabac en magasin spécialisé',
      'high',
    ],
    [
      'NAF',
      '64',
      'NAF64',
      'Activités des services financiers, hors assurance et caisses de retraite',
      'high',
    ],
    ['NAF', '64.1', 'NAF64.1', 'Intermédiation monétaire', 'high'],
    ['NAF', '64.11', 'NAF64.11', 'Activités de banque centrale', 'high'],
    ['NAF', '64.11Z', 'NAF64.11Z', 'Activités de banque centrale', 'high'],
    ['NAF', '64.19', 'NAF64.19', 'Autres intermédiations monétaires', 'high'],
    ['NAF', '64.19Z', 'NAF64.19Z', 'Autres intermédiations monétaires', 'high'],
    ['NAF', '64.2', 'NAF64.2', 'Activités des sociétés holding', 'high'],
    ['NAF', '64.20', 'NAF64.20', 'Activités des sociétés holding', 'high'],
    ['NAF', '64.20Z', 'NAF64.20Z', 'Activités des sociétés holding', 'high'],
    [
      'NAF',
      '64.3',
      'NAF64.3',
      'Fonds de placement et entités financières similaires',
      'high',
    ],
    [
      'NAF',
      '64.30',
      'NAF64.30',
      'Fonds de placement et entités financières similaires',
      'high',
    ],
    [
      'NAF',
      '64.30Z',
      'NAF64.30Z',
      'Fonds de placement et entités financières similaires',
      'high',
    ],
    [
      'NAF',
      '64.9',
      'NAF64.9',
      'Autres activités des services financiers, hors assurance et caisses de retraite',
      'high',
    ],
    ['NAF', '64.92', 'NAF64.92', 'Autre distribution de crédit', 'high'],
    ['NAF', '64.92Z', 'NAF64.92Z', 'Autre distribution de crédit', 'high'],
    [
      'NAF',
      '64.99',
      'NAF64.99',
      'Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.',
      'high',
    ],
    [
      'NAF',
      '64.99Z',
      'NAF64.99Z',
      'Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.',
      'high',
    ],
    ['NAF', '65', 'NAF65', 'Assurance', 'high'],
    ['NAF', '65.1', 'NAF65.1', 'Assurance', 'high'],
    ['NAF', '65.11', 'NAF65.11', 'Assurance vie', 'high'],
    ['NAF', '65.11Z', 'NAF65.11Z', 'Assurance vie', 'high'],
    ['NAF', '65.12', 'NAF65.12', 'Autres assurances', 'high'],
    ['NAF', '65.12Z', 'NAF65.12Z', 'Autres assurances', 'high'],
    ['NAF', '65.2', 'NAF65.2', 'Réassurance', 'high'],
    ['NAF', '65.20', 'NAF65.20', 'Réassurance', 'high'],
    ['NAF', '65.20Z', 'NAF65.20Z', 'Réassurance', 'high'],
    ['NAF', '65.3', 'NAF65.3', 'Caisses de retraite', 'high'],
    ['NAF', '65.30', 'NAF65.30', 'Caisses de retraite', 'high'],
    ['NAF', '65.30Z', 'NAF65.30Z', 'Caisses de retraite', 'high'],
    [
      'NAF',
      '66',
      'NAF66',
      "Activités auxiliaires de services financiers et d'assurance",
      'high',
    ],
    [
      'NAF',
      '66.1',
      'NAF66.1',
      'Activités auxiliaires de services financiers, hors assurance et caisses de retraite',
      'high',
    ],
    [
      'NAF',
      '66.11',
      'NAF66.11',
      'Administration de marchés financiers',
      'high',
    ],
    [
      'NAF',
      '66.11Z',
      'NAF66.11Z',
      'Administration de marchés financiers',
      'high',
    ],
    [
      'NAF',
      '66.12',
      'NAF66.12',
      'Courtage de valeurs mobilières et de marchandises',
      'high',
    ],
    [
      'NAF',
      '66.12Z',
      'NAF66.12Z',
      'Courtage de valeurs mobilières et de marchandises',
      'high',
    ],
    [
      'NAF',
      '66.19',
      'NAF66.19',
      'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite',
      'high',
    ],
    [
      'NAF',
      '66.19A',
      'NAF66.19A',
      'Supports juridiques de gestion de patrimoine mobilier',
      'high',
    ],
    [
      'NAF',
      '66.19B',
      'NAF66.19B',
      'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, n.c.a.',
      'high',
    ],
    [
      'NAF',
      '66.2',
      'NAF66.2',
      "Activités auxiliaires d'assurance et de caisses de retraite",
      'high',
    ],
    ['NAF', '66.21', 'NAF66.21', 'Évaluation des risques et dommages', 'high'],
    [
      'NAF',
      '66.21Z',
      'NAF66.21Z',
      'Évaluation des risques et dommages',
      'high',
    ],
    [
      'NAF',
      '66.22',
      'NAF66.22',
      "Activités des agents et courtiers d'assurances",
      'high',
    ],
    [
      'NAF',
      '66.22Z',
      'NAF66.22Z',
      "Activités des agents et courtiers d'assurances",
      'high',
    ],
    [
      'NAF',
      '66.29',
      'NAF66.29',
      "Autres activités auxiliaires d'assurance et de caisses de retraite",
      'high',
    ],
    [
      'NAF',
      '66.29Z',
      'NAF66.29Z',
      "Autres activités auxiliaires d'assurance et de caisses de retraite",
      'high',
    ],
    ['NAF', '66.3', 'NAF66.3', 'Gestion de fonds', 'high'],
    ['NAF', '66.30', 'NAF66.30', 'Gestion de fonds', 'high'],
    ['NAF', '66.30Z', 'NAF66.30Z', 'Gestion de fonds', 'high'],
    ['NAF', '68', 'NAF68', 'Activités immobilières', 'high'],
    [
      'NAF',
      '68.1',
      'NAF68.1',
      'Activités des marchands de biens immobiliers',
      'high',
    ],
    [
      'NAF',
      '68.10',
      'NAF68.10',
      'Activités des marchands de biens immobiliers',
      'high',
    ],
    [
      'NAF',
      '68.10Z',
      'NAF68.10Z',
      'Activités des marchands de biens immobiliers',
      'high',
    ],
    [
      'NAF',
      '68.2',
      'NAF68.2',
      'Location et exploitation de biens immobiliers propres ou loués',
      'high',
    ],
    [
      'NAF',
      '68.20',
      'NAF68.20',
      'Location et exploitation de biens immobiliers propres ou loués',
      'high',
    ],
    ['NAF', '68.20A', 'NAF68.20A', 'Location de logements', 'high'],
    [
      'NAF',
      '68.20B',
      'NAF68.20B',
      "Location de terrains et d'autres biens immobiliers",
      'high',
    ],
    [
      'NAF',
      '68.3',
      'NAF68.3',
      'Activités immobilières pour compte de tiers',
      'high',
    ],
    ['NAF', '68.31', 'NAF68.31', 'Agences immobilières', 'high'],
    ['NAF', '68.31Z', 'NAF68.31Z', 'Agences immobilières', 'high'],
    ['NAF', '68.32', 'NAF68.32', 'Administration de biens immobiliers', 'high'],
    [
      'NAF',
      '68.32A',
      'NAF68.32A',
      "Administration d'immeubles et autres biens immobiliers",
      'high',
    ],
    [
      'NAF',
      '68.32B',
      'NAF68.32B',
      'Supports juridiques de gestion de patrimoine immobilier',
      'high',
    ],
    [
      'NAF',
      '84',
      'NAF84',
      'Administration publique et défense ; sécurité sociale obligatoire',
      'high',
    ],
    [
      'NAF',
      '84.1',
      'NAF84.1',
      'Administration générale, économique et sociale',
      'high',
    ],
    ['NAF', '84.11', 'NAF84.11', 'Administration publique générale', 'high'],
    ['NAF', '84.11Z', 'NAF84.11Z', 'Administration publique générale', 'high'],
    [
      'NAF',
      '84.12',
      'NAF84.12',
      'Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale ',
      'high',
    ],
    [
      'NAF',
      '84.12Z',
      'NAF84.12Z',
      'Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale ',
      'high',
    ],
    [
      'NAF',
      '84.13',
      'NAF84.13',
      'Administration publique (tutelle) des activités économiques',
      'high',
    ],
    [
      'NAF',
      '84.13Z',
      'NAF84.13Z',
      'Administration publique (tutelle) des activités économiques',
      'high',
    ],
    ['NAF', '84.2', 'NAF84.2', 'Services de prérogative publique', 'high'],
    ['NAF', '84.21', 'NAF84.21', 'Affaires étrangères', 'high'],
    ['NAF', '84.21Z', 'NAF84.21Z', 'Affaires étrangères', 'high'],
    ['NAF', '84.23', 'NAF84.23', 'Justice', 'high'],
    ['NAF', '84.23Z', 'NAF84.23Z', 'Justice', 'high'],
    ['NAF', '84.3', 'NAF84.3', 'Sécurité sociale obligatoire', 'high'],
    ['NAF', '84.30', 'NAF84.30', 'Sécurité sociale obligatoire', 'high'],
    [
      'NAF',
      '84.30A',
      'NAF84.30A',
      'Activités générales de sécurité sociale',
      'high',
    ],
    [
      'NAF',
      '84.30B',
      'NAF84.30B',
      'Gestion des retraites complémentaires',
      'high',
    ],
    ['NAF', '84.30C', 'NAF84.30C', 'Distribution sociale de revenus', 'high'],
    ['NAF', '85', 'NAF85', 'Enseignement', 'high'],
    ['NAF', '94', 'NAF94', 'Activités des organisations associatives', 'high'],
    [
      'NAF',
      '94.1',
      'NAF94.1',
      'Activités des organisations économiques, patronales et professionnelles',
      'high',
    ],
    [
      'NAF',
      '94.11',
      'NAF94.11',
      'Activités des organisations patronales et consulaires',
      'high',
    ],
    [
      'NAF',
      '94.11Z',
      'NAF94.11Z',
      'Activités des organisations patronales et consulaires',
      'high',
    ],
    [
      'NAF',
      '94.12',
      'NAF94.12',
      'Activités des organisations professionnelles',
      'high',
    ],
    [
      'NAF',
      '94.12Z',
      'NAF94.12Z',
      'Activités des organisations professionnelles',
      'high',
    ],
    ['NAF', '94.2', 'NAF94.2', 'Activités des syndicats de salariés', 'high'],
    ['NAF', '94.20', 'NAF94.20', 'Activités des syndicats de salariés', 'high'],
    [
      'NAF',
      '94.20Z',
      'NAF94.20Z',
      'Activités des syndicats de salariés',
      'high',
    ],
    [
      'NAF',
      '94.9',
      'NAF94.9',
      'Activités des autres organisations associatives',
      'high',
    ],
    [
      'NAF',
      '94.91',
      'NAF94.91',
      'Activités des organisations religieuses',
      'high',
    ],
    [
      'NAF',
      '94.91Z',
      'NAF94.91Z',
      'Activités des organisations religieuses',
      'high',
    ],
    [
      'NAF',
      '94.92',
      'NAF94.92',
      'Activités des organisations politiques',
      'high',
    ],
    [
      'NAF',
      '94.92Z',
      'NAF94.92Z',
      'Activités des organisations politiques',
      'high',
    ],
    [
      'NAF',
      '94.99',
      'NAF94.99',
      'Activités des organisations associatives n.c.a.',
      'high',
    ],
    [
      'NAF',
      '94.99Z',
      'NAF94.99Z',
      'Autres organisations fonctionnant par adhésion volontaire',
      'high',
    ],
    [
      'NAF',
      '98',
      'NAF98',
      'Activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.1',
      'NAF98.1',
      'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.10',
      'NAF98.10',
      'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.10Z',
      'NAF98.10Z',
      'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.2',
      'NAF98.2',
      'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.20',
      'NAF98.20',
      'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
      'high',
    ],
    [
      'NAF',
      '98.20Z',
      'NAF98.20Z',
      'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
      'high',
    ],
    [
      'NAF',
      '99',
      'NAF99',
      'Activités des organisations et organismes extraterritoriaux',
      'high',
    ],
    [
      'NAF',
      '99.0',
      'NAF99.0',
      'Activités des organisations et organismes extraterritoriaux',
      'high',
    ],
    [
      'NAF',
      '99.00',
      'NAF99.00',
      'Activités des organisations et organismes extraterritoriaux',
      'high',
    ],
    [
      'NAF',
      '99.00Z',
      'NAF99.00Z',
      'Activités des organisations et organismes extraterritoriaux',
      'high',
    ],
  ],
} as const;
